import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Values from './components/Values';
import References from './components/References';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/feature/SEO';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen">
      <SEO
        title="Protection Nuisibles Pro | Dératisation, Désinsectisation, Désinfection"
        description="Protection Nuisibles Pro : expert en dératisation, désinsectisation et désinfection. Intervention rapide, certifiée et éco-responsable pour éliminer rats, souris, cafards, punaises de lit et tous nuisibles. Devis gratuit."
        keywords="dératisation, désinsectisation, désinfection, nuisibles, rats, souris, cafards, punaises de lit, frelons, guêpes, protection nuisibles"
        ogType="website"
        schema={{
          '@context': 'https://schema.org',
          '@graph': [
            {
              '@type': 'LocalBusiness',
              '@id': `${import.meta.env.VITE_SITE_URL}/#organization`,
              name: 'Protection Nuisibles Pro',
              description: 'Expert en dératisation, désinsectisation et désinfection. Intervention rapide et certifiée pour éliminer tous types de nuisibles.',
              url: import.meta.env.VITE_SITE_URL,
              telephone: '+33-XXX-XXX-XXX',
              priceRange: '€€',
              address: {
                '@type': 'PostalAddress',
                addressCountry: 'FR'
              },
              areaServed: {
                '@type': 'Country',
                name: 'France'
              },
              serviceType: ['Dératisation', 'Désinsectisation', 'Désinfection'],
              hasOfferCatalog: {
                '@type': 'OfferCatalog',
                name: 'Services de protection contre les nuisibles',
                itemListElement: [
                  {
                    '@type': 'Offer',
                    itemOffered: {
                      '@type': 'Service',
                      name: 'Dératisation',
                      description: 'Élimination professionnelle des rats et souris'
                    }
                  },
                  {
                    '@type': 'Offer',
                    itemOffered: {
                      '@type': 'Service',
                      name: 'Désinsectisation',
                      description: 'Traitement contre cafards, punaises de lit, frelons et autres insectes'
                    }
                  },
                  {
                    '@type': 'Offer',
                    itemOffered: {
                      '@type': 'Service',
                      name: 'Désinfection',
                      description: 'Désinfection complète de locaux et véhicules'
                    }
                  }
                ]
              }
            },
            {
              '@type': 'WebSite',
              '@id': `${import.meta.env.VITE_SITE_URL}/#website`,
              url: import.meta.env.VITE_SITE_URL,
              name: 'Protection Nuisibles Pro',
              description: 'Expert en dératisation, désinsectisation et désinfection',
              publisher: {
                '@id': `${import.meta.env.VITE_SITE_URL}/#organization`
              }
            }
          ]
        }}
      />
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Services />
      <Values />
      <References />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}